import { useStore } from 'zustand'
import type { TemporalState } from 'zundo'
import type { DiagramState, DiagramStore } from './diagramStore'

type TemporalSlice = TemporalState<Pick<DiagramState, 'nodes' | 'edges'>>

/** Pure selectors — referentially stable, usable with `useStore(store, selector)`. */
export const selectNodes = (s: DiagramState) => s.nodes
export const selectEdges = (s: DiagramState) => s.edges
export const selectCanUndo = (t: TemporalSlice) => t.pastStates.length > 0
export const selectCanRedo = (t: TemporalSlice) => t.futureStates.length > 0

/** React hook: subscribe to a slice of the main store. */
export function useDiagram<T>(store: DiagramStore, selector: (s: DiagramState) => T): T {
  return useStore(store, selector)
}

/** React hook: subscribe to a slice of the temporal (undo/redo) store. */
export function useDiagramTemporal<T>(
  store: DiagramStore,
  selector: (t: TemporalSlice) => T,
): T {
  return useStore(store.temporal, selector)
}
